export default {
  REQUEST_SENT_TO_CLUB_ID: 1,
  FULFILLMENT_TYPE_SET_ID: 2,
  ORDER_DETAILS_COMPLETE_ID: 3,
  ORDER_CHARGED_ID: 4,
  TICKET_SENT_TO_RECIPIENT_ID: 5,
  CONFIRMATION_EMAIL_SENT_ID: 6,
};
